import {
  type ClientActionFunctionArgs,
  useLoaderData,
  useNavigation,
} from 'react-router';

import type { Route } from './+types/$orgSlug.event.$eventSlug._index';

import { RegisterPage } from '~/pages/RegisterPage';
import { loader as registerLoader } from '~/pages/RegisterPage/loader';
import { action as registerAction } from '~/pages/RegisterPage/action';
import { handle as registerHandle } from '~/pages/RegisterPage/handle';
import { clearWrapperLoaderCache } from '~/pages/FormPage/wrapper';

export const meta = ({ loaderData }: Route.MetaArgs) => {
  return [
    { title: loaderData.event.name },
    {
      name: 'description',
      content: loaderData.event.shortDescription,
    },
  ];
};

export const loader = registerLoader;
export const action = registerAction;
export const handle = registerHandle;

export async function clientAction({ serverAction }: ClientActionFunctionArgs) {
  clearWrapperLoaderCache();
  return serverAction();
}

export default function Register() {
  const {
    event,
    organization,
    hasCustomDomain,
    isAuthenticated,
    userProfiles,
    userProfilesCanBeDeleted,
    registeredUsersLookup,
  } = useLoaderData<typeof loader>();
  const navigation = useNavigation();

  return (
    <RegisterPage
      isLoading={navigation.state === 'submitting'}
      event={event}
      organization={organization}
      hasCustomDomain={hasCustomDomain}
      isAuthenticated={isAuthenticated}
      userProfiles={userProfiles}
      userProfilesCanBeDeleted={userProfilesCanBeDeleted}
      registeredUsersLookup={registeredUsersLookup}
    />
  );
}
